import { Grid } from '@mantine/core';
import {
  BusinessBankAccountDepositTypes,
  BusinessBankAccountTypes,
} from '../../../enums/bank.enums';
import { Currency } from '../../../enums/retrieve-transaction.enums';
import { BusinessOnboardingInformation } from '../../../type/admin.types';
import { TextInfo } from '../../safe-text/safe-text.component';
import XColEmpty from '../../x-components/grid-col/x-col-empty.component';

interface Props {
  index: number;
  businessData: BusinessOnboardingInformation;
}
function MerchantInfoSettlement(props: Props) {
  const { businessData, index } = props;

  return (
    <>
      <Grid>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Deposit to Account'
            value={
              BusinessBankAccountDepositTypes.PAYMAYA ===
              businessData.banks[index].accountDepositTypeId
                ? 'PAYMAYA'
                : BusinessBankAccountDepositTypes.GCASH ===
                  businessData.banks[index].accountDepositTypeId
                ? 'GCASH'
                : BusinessBankAccountDepositTypes.NO_ACCOUNT ===
                  businessData.banks[index].accountDepositTypeId
                ? 'NO ACCOUNT'
                : 'BANK'
            }
            dataCy='accountDepositTypeId'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Bank Name'
            value={businessData.banks[index].bankName?.replace(/_/g, ' ')}
            dataCy='bankName'
          />
        </Grid.Col>

        <XColEmpty md={6} disappearAtSmallerThan='md' />
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Account Name'
            value={businessData.banks[index].accountName}
            dataCy='accountName'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Account Number'
            value={businessData.banks[index].accountNumber}
            dataCy='accountNumber'
          />
        </Grid.Col>
        {businessData.banks[index].accountDepositTypeId ===
          BusinessBankAccountDepositTypes.BANK && (
          <Grid.Col md={3} sm={6}>
            <TextInfo
              label='Account Type'
              value={
                BusinessBankAccountTypes.SAVINGS ===
                businessData.banks[index].accountTypeId
                  ? 'Savings'
                  : 'Checking/Current'
              }
              dataCy='accountType'
            />
          </Grid.Col>
        )}
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label='Currency'
            value={
              businessData.banks[index].currencyId === Currency.PHP
                ? 'PHP'
                : businessData.banks[index].currencyId === Currency.USD
                ? 'USD'
                : '.'
            }
            dataCy='accountType'
          />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default MerchantInfoSettlement;
